import React, { useState, useEffect, useRef } from "react";
import { PhoneCountryCode } from "../country";

export const Input = ({ label, value, onChange, type, name }) => {
  return (
    <>
      <label for={name} className="block text-sm leading-6 text-white text-xl">
        {label}
      </label>
      <div className="pb-6">
        <div className="relative mt-2 rounded-md shadow-sm">
          <input
            name={name}
            id={name}
            className="block h-[3.4rem] w-full rounded-md border-0 py-1.5 pl-7 pr-20 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-white sm:text-sm sm:leading-6"
            placeholder={`Enter your ${name}`}
            value={value}
            onChange={onChange}
            type={type || "text"}
            required
          />
        </div>
      </div>
    </>
  );
};

export const PhoneInput = ({ code, onChange, label, name, value }) => {
  const [show, setShow] = useState(false);
  let countryCode = PhoneCountryCode();
  let selectedCode = countryCode.find((arr) => arr.dial_code === code);

  const ref = useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!ref?.current?.contains(event.target)) {
        setShow(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
  }, [ref]);

  return (
    <>
      <label
        for={name}
        className="block text-sm leading-6 text-white text-xl pb-2"
      >
        {label}
      </label>
      <div class="flex items-center relative pb-6" ref={ref}>
        <button
          class="h-[3.4rem] flex-shrink-0 z-10 inline-flex items-center py-2.5 px-4 text-sm font-medium text-center text-gray-900 bg-gray-100 border border-gray-300 rounded-s-lg hover:bg-gray-200 focus:ring-4 focus:outline-none focus:ring-gray-100 dark:bg-gray-700 dark:hover:bg-gray-600 dark:focus:ring-gray-700 dark:text-white dark:border-gray-600"
          type="button"
          onClick={() => setShow(!show)}
        >
          {selectedCode.emoji + " " + selectedCode.dial_code}
          <svg
            class="w-2.5 h-2.5 ms-2.5"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 10 6"
          >
            <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="m1 1 4 4 4-4"
            />
          </svg>
        </button>
        <label
          for="phone-input"
          class="mb-2 text-sm font-medium text-gray-900 sr-only dark:text-white"
        >
          Phone number:
        </label>
        <div class="relative w-full">
          <input
            type="text"
            id="phone-input"
            class="block h-[3.4rem] p-2.5 w-full z-20 text-sm text-gray-900 bg-gray-50 rounded-e-lg border-s-0 border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-s-gray-700  dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:border-blue-500"
            placeholder="Enter your phone number"
            required
            maxLength={15}
            name={name}
            value={value}
            onChange={onChange}
          />
        </div>
        {show && (
          <div class="z-10 bg-white divide-y divide-gray-100 rounded-lg shadow w-52 dark:bg-gray-700 absolute top-11">
            <ul class="py-2 text-sm text-gray-700 dark:text-gray-200 overflow-auto h-72">
              {countryCode.map((arr, i) => {
                if (arr?.dial_code) {
                  return (
                    <li
                      key={i}
                      style={{
                        background: arr.dial_code === value && "#6ecd6e85",
                      }}
                    >
                      <button
                        type="button"
                        class="inline-flex w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-200 dark:hover:bg-gray-600 dark:hover:text-white"
                        onClick={() =>
                          onChange({
                            target: {
                              name: "country_code",
                              value: arr.dial_code,
                            },
                          })
                        }
                      >
                        <div class="inline-flex items-center">
                          {arr.emoji + " " + arr.name + " " + arr.dial_code}
                        </div>
                      </button>
                    </li>
                  );
                }
              })}
            </ul>
          </div>
        )}
      </div>
    </>
  );
};
